import React from 'react';
import { Timer } from 'lucide-react';
import { useOrganization } from '../../contexts/OrganizationContext';
import OrgSlaSection from '../../components/organization/OrgSlaSection';
import { Spinner } from '../../design-system';

const SlaSettingsPage: React.FC = () => {
  const { currentOrganization, isLoading } = useOrganization();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-64">
        <Spinner size={32} />
      </div>
    );
  }

  if (!currentOrganization) {
    return (
      <div className="max-w-4xl mx-auto px-4 sm:px-6 py-6 sm:py-8">
        <div className="text-center text-ui-text-tertiary">
          Please select an organization to view SLA settings.
        </div>
      </div>
    );
  }

  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 py-6 sm:py-8">
      {/* Header */}
      <div className="flex items-center gap-4 mb-8">
        <div className="w-12 h-12 bg-ui-background-tertiary rounded-xl flex items-center justify-center">
          <Timer className="w-6 h-6 text-ui-text-secondary" />
        </div>
        <div>
          <h1 className="text-2xl font-bold text-ui-text-primary">
            SLA Settings
          </h1>
          <p className="text-sm text-ui-text-tertiary mt-1">
            Configure remediation timelines and business calendar
          </p>
        </div>
      </div>

      {/* SLA Configuration */}
      <OrgSlaSection organizationId={currentOrganization.id} />
    </div>
  );
};

export default SlaSettingsPage;
